import {load_advancedScroller, load_testimonialRotator} from "./_previewHelpers";
import {loadScript, loadStylesheet, get_query_arg} from "../main.source";

export function initOtherScripts($) {


  let as0_offset = 20000;
  let tr0_offset = 20000;

  setTimeout(function () {
    const $as = $("#as0");
    const $tr = $("#tr0");

    if ($as.length) {

      as0_offset = $as.offset().top;
    }
    if ($tr.length) {
      tr0_offset = $tr.offset().top;
    }
  }, 2000);
  setTimeout(function () {

  }, 2000);
  setTimeout(function () {
    load_advancedScroller();
    load_testimonialRotator();
  }, 15000);


  setTimeout(function () {


    loadScript('libs/dzsparallaxer/dzsparallaxer.js');
  }, 6000);


  let loadPreseterTime = 4000;

  if(get_query_arg(window.location.href, 'player_skin')){
    loadPreseterTime = 2;
  }
  setTimeout(function () {

    loadScript('preseter/preseter.js');

    loadStylesheet('https://maxcdn.bootstrapcdn.com/font-awesome/4.6.0/css/font-awesome.min.css');
    loadStylesheet('colorpicker/farbtastic.css');
    loadScript('colorpicker/farbtastic.js');
  }, loadPreseterTime);


  $(window).on('scroll.checkzfolio', function () {

    var st = $(window).scrollTop();

    var wh = $(window).height();


    if (st + wh > as0_offset) {
      load_advancedScroller();
      load_testimonialRotator();

      $(window).off('scroll.checkzfolio');
    }
  });

}